import { ViewContainerRef, ViewChild } from "@angular/core";
import { FieldType } from "./field.type";
import { KreFormFieldConfig } from "../components/kre-form.field.config";

export abstract class FieldWrapper<
  F extends KreFormFieldConfig = KreFormFieldConfig
> extends FieldType<F> {
  @ViewChild("fieldComponent", <any>{ read: ViewContainerRef, static: false })
  fieldComponent: ViewContainerRef;

  get to() {
    return this.field.templateOptions || {};
  }

  get tags() {
    return this.to.tags || {};
  }
}
